import { Layout } from './lib/layout';
import { Context } from './lib/UIShell/context';

export { Headline } from './lib/headline';
export { UIShell } from './lib/UIShell/UIShell';
export { Layout };

export const ApplicationContext: typeof Context = Context;
export const Page = Layout;
